import type { Dispatch, SetStateAction } from 'react'
import { useRef, useState, useEffect } from 'react'

interface RefType {
  current: HTMLElement | null;
  contains: (target: HTMLElement) => boolean;
}

// eslint-disable-next-line
type Tuple = [any, boolean, Dispatch<SetStateAction<boolean>>]
type UseOutsideClickType = (initialState: boolean) => Tuple

const useOutsideClick: UseOutsideClickType = initialState => {
  const ref = useRef<RefType>(null)
  const [isOpen, setOpen] = useState(initialState)

  const handleClick: (event: Event | MouseEvent) => void = event => {
    if (ref?.current && !ref?.current?.contains(event?.target as HTMLElement)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  return [
    ref,
    isOpen,
    setOpen
  ]
}

export default useOutsideClick
